/**
 * useFeatureAccess Hook
 *
 * Custom hook for checking feature access in components
 */

import { useContext } from "react";
import {
  FeatureAccessContext,
  type FeatureAccessContextType,
} from "../contexts/FeatureAccessContext";

/**
 * Hook to access feature gating functionality
 *
 * @example
 * ```typescript
 * const { hasFeature } = useFeatureAccess();
 * if (!hasFeature('feature-custom-assumptions')) {
 *   return <UpgradePrompt />;
 * }
 * ```
 */
export function useFeatureAccess(): FeatureAccessContextType {
  const context = useContext(FeatureAccessContext);

  if (!context) {
    throw new Error(
      "useFeatureAccess must be used within a FeatureAccessProvider"
    );
  }

  return context;
}
